module.exports = __webpack_public_path__ + "static/media/05_after.49c7e83d.jpg";